import { Controller } from "@hotwired/stimulus"

// Shows the content target only while the checkbox is ticked.
export default class extends Controller {
  static targets = ["content"]

  toggle({ target }) {
    this.contentTarget.classList.toggle("hidden", !target.checked)
  }
}
